const globalState = {
  tiposUnidad: [],
  tiposPrestaciones: [],
  tiposPrestacionesIsapre: [],
  itemsImed: [],
  tiposProfesionales: [],
  pertenenciasFonasa: [],
  estadosSolicitud: [],
  tiposSolicitud: [],
  tiposArancel: [],

  // Filtro CentroAtencion->Arancel->TipoPrestacion : CAT
  filtros_CAT: {
    centrosAtencion: [],
    tiposArancel: [],
    tiposPrestaciones: [],
    centroAtencion: null,
    tipoArancel: null,
    tipoPrestacion: null,
    codFonasa: null,
    codPrestacion: null,
  },

  dialogGeneric: {
    open: false,
    contenido: "",
  },

  rutInstitucion: /* 96770100 */ 90753000,
  rutInstitucionDv: "0",
  nombreInstitucion: "",
  rutPrestador: /* 96770100 */ 90753000,
  rutUsuario: /*9917926*/ 13483654,
  isapre: "B",
  IdSolicitud: null,
  IdEstadoSolicitud: null,
  token: '7f86e43faa494144b10fa08796362efc',
  listaUsuariosConvenio: null,
  listaUsuariosContraloria: null,
  datosUsuario: {
    nombre: "",
    mail: "",
  },

  // TODO: Pasar como variables de ambiente
  ENV: {
    // monto maximo fonasa
    montoMaximoFonasa: 20,
    // Dias minimos en fecha vigencia de solicitudes
    REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: 15,

    // Permite enviar una solicitud cuando existe una en curso
    ENVIAR_SOLICITUD_CUANDO_EXISTE_EN_CURSO: false,

    // Permite deshabilitar el borrador de actualizar arancel
    DESHABILITAR_BORRADOR: false,

    // Grupos Prestaciones que no validan guarismo
    GRUPOS_NO_VALIDAN_GUARISMO: [0, 1, 3, 4, 5, 7, 8, 10, 12, 13, 16, 21, 22, 23, 24, 27, 28, 29, 30, 31, 32, 34, 35, 36, 38, 40, 41, 42, 45, 46, 47, 49],

    // Profesionales que validan guarismo
    PROFESIONALES_NO_VALIDAN_GUARISMO: ["**", "CI", "AL", "A1", "A2", "A3", "CA", "PE"],

    // Grupos prestaciones que no validan item IMED
    GRUPOS_NO_VALIDAN_ITEMIMED: [{
      IdGrupo: 9,
      ItemImed: [1],
    },
    {
      IdGrupo: 15,
      ItemImed: [8],
    },
    {
      IdGrupo: 25,
      ItemImed: [1],
    },
    {
      IdGrupo: 26,
      ItemImed: [8],
    },
    ],
  },
};


export default globalState;
